import { FormInput } from 'src/@types';
import { getDefaultValue } from 'src/components/shared/form-elements';
import { CalculatorAdditionalPaymentStep1FormFields } from '../types';
import { IntlShape } from 'react-intl/src/types';

export const useAdditionalPaymentStep1FormFields = (intl: IntlShape) => {
  const AdditionalPaymentStep1FormFields: Record<
    keyof CalculatorAdditionalPaymentStep1FormFields,
    FormInput
  > = {
    mortgageType: {
      fieldName: 'mortgageType',
      label: intl.formatMessage({
        id: 'step1.mortgageType',
        defaultMessage: 'Hypotheekvorm(en)'
      }),
      type: 'select',
      tooltip: intl.formatMessage({
        id: 'step1.mortgageType.tooltip',
        defaultMessage:
          'Kies de juiste hypotheekvorm(en):<br/>' +
          'Annuïteitenhypotheek – als de hypotheek helemaal annuïtair afgelost wordt.<br/>' +
          'Annuïteiten + aflossingsvrij – als de annuïteitenhypotheek een aflossingsvrij deel heeft.<br/>' +
          'Aflossingsvrije hypotheek – als de hypotheek helemaal aflossingsvrij is.<br/>' +
          'Lineaire hypotheek – als de hypotheek helemaal lineair afgelost wordt.<br/>' +
          'Lineair + aflossingsvrij – als de lineaire hypotheek een aflossingsvrij deel heeft.'
      }),
      options: [
        {
          label: intl.formatMessage({
            id: 'step1.paymentType.option.annuiteitenhypotheek',
            defaultMessage: 'Annuïteitenhypotheek'
          }),
          value: 'ann'
        },
        {
          label: intl.formatMessage({
            id: 'step1.paymentType.option.annuiteitenAflossingsvrij',
            defaultMessage: 'Annuïteiten + aflossingsvrij'
          }),
          value: 'annafl'
        },
        {
          label: intl.formatMessage({
            id: 'step1.paymentType.option.aflossingsvrijeHypotheek',
            defaultMessage: 'Aflossingsvrije hypotheek'
          }),
          value: 'afl'
        },
        {
          label: intl.formatMessage({
            id: 'step1.paymentType.option.lineaireHypotheek',
            defaultMessage: 'Lineaire hypotheek'
          }),
          value: 'lin'
        },
        {
          label: intl.formatMessage({
            id: 'step1.paymentType.option.lineairAflossingsvrij',
            defaultMessage: 'Lineair + aflossingsvrij'
          }),
          value: 'linafl'
        }
      ],
      required: true,
      defaultValue: getDefaultValue('ann', true)
    },
    remainingTerm: {
      fieldName: 'remainingTerm',
      label: intl.formatMessage({
        id: 'step1.remainingTerm',
        defaultMessage: 'Wanneer eindigt je huidige hypotheek?'
      }),
      type: 'date',
      required: true,
      defaultValue: getDefaultValue('2035-09-27')
    },
    mortgageAmount: {
      fieldName: 'mortgageAmount',
      label: intl.formatMessage({
        id: 'step1.mortgageAmount',
        defaultMessage: 'Resterende deel'
      }),
      type: 'currency',
      required: true,
      removeDecimals: true,
      placeHolder: '€ 200.000',
      defaultValue: getDefaultValue('200000')
    },
    mortgageInterestRate: {
      fieldName: 'mortgageInterestRate',
      label: intl.formatMessage({
        id: 'step1.mortgageInterestRate',
        defaultMessage: 'Hypotheekrente'
      }),
      type: 'percentage',
      required: true,
      placeHolder: '2,5%',
      tooltip: intl.formatMessage({
        id: 'step1.mortgageInterestRate.tooltip',
        defaultMessage:
          'Wat is de rente die u betaalt voor uw hypotheeklening? Vul hier de nominale rente in, dat is de rente die in de polis staat.'
      }),
      defaultValue: getDefaultValue('2.5')
    },
    mortgageAmount2: {
      fieldName: 'mortgageAmount2',
      label: intl.formatMessage({
        id: 'step1.mortgageAmount2',
        defaultMessage: 'Resterende deel'
      }),
      type: 'currency',
      removeDecimals: true,
      placeHolder: '€ 200.000',
      defaultValue: getDefaultValue('200000')
    },
    mortgageInterestRate2: {
      fieldName: 'mortgageInterestRate2',
      label: intl.formatMessage({
        id: 'step1.mortgageInterestRate2',
        defaultMessage: 'Hypotheekrente'
      }),
      type: 'percentage',
      removeDecimals: true,
      placeHolder: '2,5%',
      tooltip: intl.formatMessage({
        id: 'step1.mortgageInterestRate2.tooltip',
        defaultMessage:
          'Wat is de rente die u betaalt voor uw hypotheeklening? Vul hier de nominale rente in, dat is de rente die in de polis staat.'
      }),
      defaultValue: getDefaultValue('2.5')
    }
  };
  return AdditionalPaymentStep1FormFields;
};
